import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getPiggyBankConfigsAction } from '../../../services/request';
import { PiggyBankList } from './piggy-bank/PiggyBankList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const PiggyBankRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getPiggyBankConfigsAction(search, 'GET'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [configs, setConfigs] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    if (!loading && !error) {
      setConfigs(payload.results);
    }
  }, [loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setConfigs(
        _.map(configs, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setConfigs(_.filter(configs, obj => obj.id !== obj2.id));
    } else {
      setConfigs([obj2, ...configs]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <PiggyBankList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        configs={configs}
        queryCallback={queryCallback}
        submitCallback={submitCallback} />
    </>
  );
};
